import { Component, OnInit } from "@angular/core";
import {
  getCurrentUser,
  GetCurrentUserOutput,
  signInWithRedirect,
  signOut,
} from "aws-amplify/auth";
import { Hub } from "aws-amplify/utils";
import { datadogRum } from "@datadog/browser-rum";
import { MDC } from "../../core/mdc.model";

@Component({
  selector: "app-auth-toolbar",
  templateUrl: "./toolbar.component.html",
  styleUrls: ["./toolbar.component.scss"],
  standalone: false,
})
export class ToolbarComponent implements OnInit {
  private datadogRumWrapper: typeof datadogRum = datadogRum;

  user: GetCurrentUserOutput = null;
  mdc: MDC;

  async ngOnInit() {
    this.updateCurrentUser();
    Hub.listen("auth", () => {
      this.updateCurrentUser();
    });
  }

  async updateCurrentUser() {
    try {
      this.user = await getCurrentUser();
      this.mdc = {
        username: this.user.username,
        email: this.user.userId,
      };
    } catch (e) {
      this.mdc = null;
      this.user = null;
    }
    this.datadogRumWrapper.addRumGlobalContext("mdc", this.mdc as any);
  }

  async signInWithGoogle() {
    await signInWithRedirect({
      provider: "Google",
    });
  }

  isAuthorized() {
    return this.user !== null;
  }

  async signOut() {
    await signOut();
  }
}
